// Hell/Dunkel-Umschalter in der Kopfzeile. Ohne eigene Wahl gilt die Systemeinstellung;
// die Wahl liegt bewusst nicht unter "structolab:", damit „Fortschritt löschen“ sie nicht entfernt.
// Wird synchron im <head> geladen, damit die Seite gleich im richtigen Schema erscheint.

import { ICON } from "./icons.ts";

const KEY = "structolab-theme";
type Theme = "light" | "dark";

function saved(): Theme | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : null;
  } catch {
    return null;
  }
}

const systemDark = () => window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
const current = (): Theme => saved() ?? (systemDark() ? "dark" : "light");

function apply(theme: Theme | null): void {
  if (theme) document.documentElement.dataset.theme = theme;
  else delete document.documentElement.dataset.theme;
}

apply(saved());

function render(btn: HTMLButtonElement): void {
  const dark = current() === "dark";
  btn.innerHTML = dark ? ICON.sun : ICON.moon;
  btn.title = dark ? "Helles Farbschema" : "Dunkles Farbschema";
  btn.setAttribute("aria-label", btn.title);
}

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".site-header");
  if (!header) return;
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "theme-toggle";
  btn.addEventListener("click", () => {
    const next: Theme = current() === "dark" ? "light" : "dark";
    try {
      localStorage.setItem(KEY, next);
    } catch {
      /* ohne Speicher gilt die Wahl nur bis zum Neuladen */
    }
    apply(next);
    render(btn);
  });
  render(btn);
  header.appendChild(btn);
  window.matchMedia?.("(prefers-color-scheme: dark)").addEventListener?.("change", () => render(btn));
});
